module.exports = __webpack_public_path__ + "img/generalitat.00593744.png";